var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYahooAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "yahoo-avatar "
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1139",
    d: "M7 16H13.6756L17.5628 26.138L21.5003 16H28L18.2129 40H11.6718L14.3509 33.6403L7 16Z",
    fill: "#5F01D1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1155",
    d: "M29.1968 25.6503C31.5146 25.6503 33.3936 27.5292 33.3936 29.8471C33.3936 32.1649 31.5146 34.0439 29.1968 34.0439C26.8788 34.0439 25 32.1649 25 29.8471C25 27.5292 26.8788 25.6503 29.1968 25.6503Z",
    fill: "#5F01D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1157",
    d: "M34.7726 24.1086H27.2173L33.9226 8H41.4498L34.7726 24.1086Z",
    fill: "#5F01D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahooAvatar);
export default __webpack_public_path__ + "static/media/yahoo-avatar.4c37a32235716a2029342820bae04af4.svg";
export { ForwardRef as ReactComponent };